export const RistoranteFactsSchema: React.FC = () => {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'ProductGroup',
        name: 'Dr. Oetker Ristorante Pizza',
        description:
          ' Tiefkühlpizza-Produktlinie von Dr. Oetker. Dr. Oetker Ristorante Pizza ist eine Tiefkühlpizza-Produktlinie, die sich durch einen dünnen, knusprigen Boden und eine italienisch-restaurantartige Positionierung auszeichnet. Die Pizza ist vorgebacken und wird gefroren für die Zubereitung im herkömmlichen Backofen verkauft. Sie bietet eine leichte, knusprige Textur mit gleichmäßig verteilten Belägen und einem ausgewogenen Geschmacksprofil, das von italienischen Pizzatraditionen inspiriert ist. Der Fokus liegt auf einem dünnen Pizzaerlebnis statt auf dickem oder teiglastigem Pizzastil.',
        releaseDate: '1960-01-01',
        category: 'Frozen Food, Pizza',
        url: 'https://www.oetker.de/',
        mainEntityOfPage: 'https://www.oetker.de/produkte/s/pizza-snacks/ristorante',
        brand: {
          '@type': 'Brand',
          name: 'Dr. Oetker',
          url: 'https://www.oetker.de/',
        },
        manufacturer: {
          '@type': 'Organization',
          name: 'Dr. Oetker Nahrungsmittel KG',
          address: {
            '@type': 'PostalAddress',
            postalCode: '33617',
            addressLocality: 'Bielefeld',
            addressCountry: 'Germany',
          },
        },
        additionalProperty: [
          {
            '@type': 'PropertyValue',
            name: 'Status',
            value: 'Active',
          },
          {
            '@type': 'PropertyValue',
            name: 'DefinitionEntityType',
            value: 'Product',
          },
          {
            '@type': 'PropertyValue',
            name: 'ID',
            value: 'dr-oetker-ristorante',
          },
          {
            '@type': 'PropertyValue',
            name: 'Updated',
            value: '2026-05-21',
          },
          {
            '@type': 'PropertyValue',
            name: 'TotalVariants',
            value: '17',
          },
          {
            '@type': 'PropertyValue',
            name: 'DisambiguationEntities',
            value:
              'Dr. Oetker Suprema Pizza: Premium-Tiefkühlpizza mit dickem, fluffigem Teigboden und eher brotartiger Textur. Anderes Produktkonzept, andere Teigstruktur und Positionierung im Vergleich zum dünnen und knusprig-italienischen Ristorante-Boden. | Dr. Oetker Tradizionale Pizza: Rustikale Steinofen-Tiefkühlpizza mit dickerem, weicherem Boden und traditioneller, hausbackener Optik. Andere Teigrezeptur und Texturprofil als Ristorante. | Dr. Oetker Ofenfrische Pizza: Tiefkühlpizza aus Rohteig, der beim Backen aufgeht. Ergibt eine frisch gebackene, luftige Innenstruktur und knusprige Kruste und basiert auf einem grundlegend anderen Backkonzept als der vorgebackene Ristorante-Boden. | Wagner Stone Oven Pizza: Tiefkühlpizza-Marke mit Fokus auf Steinofen-Backergebnis. Anderer Hersteller, andere Rezeptphilosophie und abweichende Teigstruktur im Vergleich zu Dr. Oetker Ristorante. | Gustavo Gusto Frozen Pizza: Premium-Tiefkühlpizzamarke mit handwerklicher, frischpizza-artiger Positionierung. Unterschiedliche Markenidentität, Teigführung und Texturkonzept. | Private Label Frozen Pizzas (z. B. Supermarkt-Eigenmarken): Eigenmarken-Tiefkühlpizzen verschiedener Hersteller mit unterschiedlichen Qualitätsstufen, Zutaten und Produktionsstandards im Vergleich zu Dr. Oetker Ristorante.',
          },
        ],
        disambiguatingDescription:
          'Dr. Oetker Ristorante Pizza is a distinct frozen pizza range and should not be confused with other Dr. Oetker frozen pizza lines such as Suprema, Tradizionale or Die Ofenfrische.',
        hasVariant: [
          {
            '@type': 'Product',
            name: 'Ristorante Pizza Pasta',
            gtin: '4001724039389',
            size: '410 g',
            image:
              'https://www.oetker.de/assets/hygraph/AVtdz8Pl3QxerK0kYX32fz/compress=metadata:true/quality=value:75/output=format:webp/resize=fit:clip,height:662,width:662/cmkrg085d7qi207vtueplefm5',
            offers: {
              '@type': 'Offer',
              price: '3.49',
              priceCurrency: 'EUR',
              availability: 'https://schema.org/InStock',
              url: 'https://www.oetker.de/produkte/p/ristorante-pasta',
            },
            additionalProperty: [
              { '@type': 'PropertyValue', name: 'Calories', value: '936 kcal' },
              { '@type': 'PropertyValue', name: 'Fat', value: '36 g' },
              { '@type': 'PropertyValue', name: 'Saturated Fat', value: '11 g' },
              { '@type': 'PropertyValue', name: 'Carbohydrates', value: '116 g' },
              { '@type': 'PropertyValue', name: 'Sugars', value: '12 g' },
              { '@type': 'PropertyValue', name: 'Fiber', value: '7,5 g' },
              { '@type': 'PropertyValue', name: 'Protein', value: '33 g' },
              { '@type': 'PropertyValue', name: 'Sodium', value: '4,1 g' },
              { '@type': 'PropertyValue', name: 'Vegetarian', value: 'Yes' },
              { '@type': 'PropertyValue', name: 'Vegan', value: 'No' },
              { '@type': 'PropertyValue', name: 'Gluten-Free', value: 'No' },
              { '@type': 'PropertyValue', name: 'Lactose-Free', value: 'No' },
              { '@type': 'PropertyValue', name: 'Halal', value: 'No' },
              { '@type': 'PropertyValue', name: 'MajorAllergens', value: 'Soja, Senf' },
              { '@type': 'PropertyValue', name: 'VerifiedDate', value: '21.02.2026' },
              {
                '@type': 'PropertyValue',
                name: 'Ingredients',
                value:
                  'WEIZENMEHL, 24% Gabelspaghetti (Wasser, HARTWEIZENGRIESS), 16% Tomatenpüree, 14% KÄSE (schnittfester MOZZARELLA, EDAMER), Wasser, Rapsöl, Spinat, natives Olivenöl extra, Zucker, Backhefe, Salz, Basilikum, Branntweinessig, Gewürze, modifizierte Stärke, Knoblauch, Petersilie, Oregano, Säuerungsmittel (Citronensäure)',
              },
            ],
          },
          {
            '@type': 'Product',
            name: 'Ristorante Salame Mozzarella Pesto',
            gtin: '4001724039297',
            size: '360 g',
            image:
              'https://www.oetker.de/assets/hygraph/AVtdz8Pl3QxerK0kYX32fz/compress=metadata:true/quality=value:75/output=format:webp/resize=fit:clip,height:662,width:662/cmnxsex4ziohh07ulnfm6q86t',
            offers: {
              '@type': 'Offer',
              price: '3.49',
              priceCurrency: 'EUR',
              availability: 'https://schema.org/InStock',
              url: 'https://www.oetker.de/produkte/p/ristorante-salame-mozzarella-pesto',
            },
            additionalProperty: [
              { '@type': 'PropertyValue', name: 'Calories', value: '920 kcal' },
              { '@type': 'PropertyValue', name: 'Fat', value: '49 g' },
              { '@type': 'PropertyValue', name: 'Saturated Fat', value: '16 g' },
              { '@type': 'PropertyValue', name: 'Carbohydrates', value: '83 g' },
              { '@type': 'PropertyValue', name: 'Sugars', value: '10 g' },
              { '@type': 'PropertyValue', name: 'Fiber', value: '6,3 g' },
              { '@type': 'PropertyValue', name: 'Protein', value: '32 g' },
              { '@type': 'PropertyValue', name: 'Sodium', value: '4,2 g' },
              { '@type': 'PropertyValue', name: 'Vegetarian', value: 'No' },
              { '@type': 'PropertyValue', name: 'Vegan', value: 'No' },
              { '@type': 'PropertyValue', name: 'Gluten-Free', value: 'No' },
              { '@type': 'PropertyValue', name: 'Lactose-Free', value: 'No' },
              { '@type': 'PropertyValue', name: 'Halal', value: 'No' },
              { '@type': 'PropertyValue', name: 'MajorAllergens', value: 'Soja, Senf' },
              { '@type': 'PropertyValue', name: 'VerifiedDate', value: '21.02.2026' },
              {
                '@type': 'PropertyValue',
                name: 'Ingredients',
                value:
                  'WEIZENMEHL, 18% Tomatenpüree, 10% schnittfester MOZZARELLA KÄSE, 9,4% Cherrytomaten, Wasser, 8,1% Pepperoni-Salami (Schweinefleisch, Speck, Salz, Gewürze, Dextrose, Knoblauchpulver, Gewürzextrakte, Stabilisator (Natriumnitrit), Antioxidationsmittel (Extrakt aus Rosmarin, Natriumascorbat), Rauch), EDAMER KÄSE, Rapsöl, natives Olivenöl extra, Basilikum, Backhefe, Salz, Zucker, Petersilie, 0,3% PECORINO HARTKÄSE, Knoblauch, Zwiebeln, Oregano, Pfeffer, Zitronensaft, Paprika, Röstzwiebeln.',
              },
            ],
          },
          {
            '@type': 'Product',
            name: 'Ristorante Margherita Pomodori Vegan',
            gtin: '4001724039655',
            size: '340 g',
            image:
              'https://www.oetker.de/assets/hygraph/AVtdz8Pl3QxerK0kYX32fz/compress=metadata:true/quality=value:75/output=format:webp/resize=fit:clip,height:662,width:662/cmnxs040dhqi207ulmdbcgw66',
            offers: {
              '@type': 'Offer',
              price: '3.49',
              priceCurrency: 'EUR',
              availability: 'https://schema.org/InStock',
              url: 'https://www.oetker.de/produkte/p/ristorante-margherita-pomodori-vegan',
            },
            additionalProperty: [
              { '@type': 'PropertyValue', name: 'Calories', value: '760 kcal' },
              { '@type': 'PropertyValue', name: 'Fat', value: '35 g' },
              { '@type': 'PropertyValue', name: 'Saturated Fat', value: '11 g' },
              { '@type': 'PropertyValue', name: 'Carbohydrates', value: '93 g' },
              { '@type': 'PropertyValue', name: 'Sugars', value: '14 g' },
              { '@type': 'PropertyValue', name: 'Fiber', value: '8,4 g' },
              { '@type': 'PropertyValue', name: 'Protein', value: '14 g' },
              { '@type': 'PropertyValue', name: 'Sodium', value: '3,5 g' },
              { '@type': 'PropertyValue', name: 'Vegetarian', value: 'Yes' },
              { '@type': 'PropertyValue', name: 'Vegan', value: 'Yes' },
              { '@type': 'PropertyValue', name: 'Gluten-Free', value: 'No' },
              { '@type': 'PropertyValue', name: 'Lactose-Free', value: 'No' },
              { '@type': 'PropertyValue', name: 'Halal', value: 'No' },
              { '@type': 'PropertyValue', name: 'MajorAllergens', value: 'Soja, Senf, Milch' },
              { '@type': 'PropertyValue', name: 'VerifiedDate', value: '21.02.2026' },
              {
                '@type': 'PropertyValue',
                name: 'Ingredients',
                value:
                  'WEIZENMEHL, 13% passierte Tomaten, 11% geriebener Pizzabelag auf Kokosölbasis (Wasser, modifizierte Kartoffelstärke, Kokosöl, Meersalz, Farbstoff (Carotin), Antioxidationsmittel (Ascorbinsäure)), 11% Cherrytomaten, Wasser, 6,8% Tomatenkonzentrat, 5,6% getrocknete, marinierte Tomatenstücke (getrocknete Tomaten, Sonnenblumenöl, Salz, Knoblauch, Kräuter, Säuerungsmittel (Citronensäure)), Rapsöl, Olivenöl nativ extra, Basilikum, Backhefe, Salz, Zucker, Petersilie, Zwiebeln, Knoblauch, Oregano, Pfeffer, Zitronensaft, Paprika, Röstzwiebeln.',
              },
            ],
          },
          {
            '@type': 'Product',
            name: 'Ristorante Pepperoni-Salame',
            gtin: '4001724039204',
            size: '320 g',
            image:
              'https://www.oetker.de/assets/hygraph/AVtdz8Pl3QxerK0kYX32fz/compress=metadata:true/quality=value:75/output=format:webp/resize=fit:clip,height:662,width:662/cmni1oy8un50x08vxw7hj623d',
            offers: {
              '@type': 'Offer',
              price: '3.49',
              priceCurrency: 'EUR',
              availability: 'https://schema.org/InStock',
              url: 'https://www.oetker.de/produkte/p/ristorante-pepperoni-salame',
            },
            additionalProperty: [
              { '@type': 'PropertyValue', name: 'Calories', value: '839 kcal' },
              { '@type': 'PropertyValue', name: 'Fat', value: '40 g' },
              { '@type': 'PropertyValue', name: 'Saturated Fat', value: '13 g' },
              { '@type': 'PropertyValue', name: 'Carbohydrates', value: '82 g' },
              { '@type': 'PropertyValue', name: 'Sugars', value: '9,5 g' },
              { '@type': 'PropertyValue', name: 'Fiber', value: '6 g' },
              { '@type': 'PropertyValue', name: 'Protein', value: '33 g' },
              { '@type': 'PropertyValue', name: 'Sodium', value: '4,2 g' },
              { '@type': 'PropertyValue', name: 'Vegetarian', value: 'No' },
              { '@type': 'PropertyValue', name: 'Vegan', value: 'No' },
              { '@type': 'PropertyValue', name: 'Gluten-Free', value: 'No' },
              { '@type': 'PropertyValue', name: 'Lactose-Free', value: 'No' },
              { '@type': 'PropertyValue', name: 'Halal', value: 'No' },
              { '@type': 'PropertyValue', name: 'MajorAllergens', value: 'Soja, Senf' },
              { '@type': 'PropertyValue', name: 'VerifiedDate', value: '21.02.2026' },
              {
                '@type': 'PropertyValue',
                name: 'Ingredients',
                value:
                  'WEIZENMEHL, 22% Tomatenpüree, 15% KÄSE (schnittfester MOZZARELLA, EDAMER), 13% Pepperoni-Salami (Schweinefleisch, Speck, Salz, Gewürze, Dextrose, Zwiebelpulver, Knoblauchpulver, Gewürzextrakte, Stabilisator (Natriumnitrit), Antioxidationsmittel (Extrakt aus Rosmarin, Natriumascorbat), Rauch), Wasser, Rapsöl, Backhefe, Salz, Zucker, natives Olivenöl extra, Oregano, Basilikum, Pfeffer, Paprika, Petersilie.',
              },
            ],
          },
          {
            '@type': 'Product',
            name: 'Ristorante Speciale',
            gtin: '4001724039051',
            size: '345 g',
            image:
              'https://www.oetker.de/assets/hygraph/AVtdz8Pl3QxerK0kYX32fz/compress=metadata:true/quality=value:75/output=format:webp/resize=fit:clip,height:662,width:662/cmnxsen9viobi07ump2rh9bks',
            offers: {
              '@type': 'Offer',
              price: '3.49',
              priceCurrency: 'EUR',
              availability: 'https://schema.org/InStock',
              url: 'https://www.oetker.de/produkte/p/ristorante-speciale',
            },
            additionalProperty: [
              { '@type': 'PropertyValue', name: 'Calories', value: '834 kcal' },
              { '@type': 'PropertyValue', name: 'Fat', value: '39 g' },
              { '@type': 'PropertyValue', name: 'Saturated Fat', value: '13 g' },
              { '@type': 'PropertyValue', name: 'Carbohydrates', value: '81 g' },
              { '@type': 'PropertyValue', name: 'Sugars', value: '9 g' },
              { '@type': 'PropertyValue', name: 'Fiber', value: '6,2 g' },
              { '@type': 'PropertyValue', name: 'Protein', value: '36 g' },
              { '@type': 'PropertyValue', name: 'Sodium', value: '4,4 g' },
              { '@type': 'PropertyValue', name: 'Vegetarian', value: 'No' },
              { '@type': 'PropertyValue', name: 'Vegan', value: 'No' },
              { '@type': 'PropertyValue', name: 'Gluten-Free', value: 'No' },
              { '@type': 'PropertyValue', name: 'Lactose-Free', value: 'No' },
              { '@type': 'PropertyValue', name: 'Halal', value: 'No' },
              { '@type': 'PropertyValue', name: 'MajorAllergens', value: 'Soja, Senf' },
              { '@type': 'PropertyValue', name: 'VerifiedDate', value: '21.02.2026' },
              {
                '@type': 'PropertyValue',
                name: 'Ingredients',
                value:
                  'WEIZENMEHL, 18% Tomatenpüree, 15% KÄSE (schnittfester MOZZARELLA, EDAMER), Wasser, Salami (Schweinefleisch, Speck, Salz, Gewürze, Dextrose, Zwiebelpulver, Knoblauchpulver, Gewürzextrakte, Stabilisator (Natriumnitrit), Antioxidationsmittel (Extrakt aus Rosmarin, Natriumascorbat), Rauch), 5,6% gekochter Hinterschinken (Schweinefleisch, Wasser, Salz, Dextrose, Stabilisatoren (Diphosphate, Triphosphate, Natriumnitrit), Antioxidationsmittel (Natriumascorbat), Gewürzextrakte), 5,6% Champignons, Rapsöl, Pepperoni-Salami (Schweinefleisch, Speck, Salz, Gewürze, Dextrose, Zwiebelpulver, Knoblauchpulver, Gewürzextrakte, Stabilisator (Natriumnitrit), Antioxidationsmittel (Extrakt aus Rosmarin, Natriumascorbat), Rauch), Backhefe, Salz, Zucker, natives Olivenöl extra, Oregano, Basilikum, Pfeffer, Paprika, Petersilie',
              },
            ],
          },
          {
            '@type': 'Product',
            name: 'Ristorante Funghi',
            gtin: '4001724038931',
            size: '365 g',
            image:
              'https://www.oetker.de/assets/hygraph/AVtdz8Pl3QxerK0kYX32fz/compress=metadata:true/quality=value:75/output=format:webp/resize=fit:clip,height:662,width:662/cmnxshrxbivyc07ulsh7cw8we',
            offers: {
              '@type': 'Offer',
              price: '3.49',
              priceCurrency: 'EUR',
              availability: 'https://schema.org/InStock',
              url: 'https://www.oetker.de/produkte/p/ristorante-funghi',
            },
            additionalProperty: [
              { '@type': 'PropertyValue', name: 'Calories', value: '829 kcal' },
              { '@type': 'PropertyValue', name: 'Fat', value: '42 g' },
              { '@type': 'PropertyValue', name: 'Saturated Fat', value: '10 g' },
              { '@type': 'PropertyValue', name: 'Carbohydrates', value: '81 g' },
              { '@type': 'PropertyValue', name: 'Sugars', value: '8,4 g' },
              { '@type': 'PropertyValue', name: 'Fiber', value: '6,8 g' },
              { '@type': 'PropertyValue', name: 'Protein', value: '29 g' },
              { '@type': 'PropertyValue', name: 'Sodium', value: '3,5 g' },
              { '@type': 'PropertyValue', name: 'Vegetarian', value: 'Yes' },
              { '@type': 'PropertyValue', name: 'Vegan', value: 'No' },
              { '@type': 'PropertyValue', name: 'Gluten-Free', value: 'No' },
              { '@type': 'PropertyValue', name: 'Lactose-Free', value: 'No' },
              { '@type': 'PropertyValue', name: 'Halal', value: 'No' },
              { '@type': 'PropertyValue', name: 'MajorAllergens', value: 'Senf' },
              { '@type': 'PropertyValue', name: 'VerifiedDate', value: '21.02.2026' },
              {
                '@type': 'PropertyValue',
                name: 'Ingredients',
                value:
                  'WEIZENMEHL, 19% Tomatenpüree, 16% Champignons, 9,0% EDAMER KÄSE, Wasser, Rapsöl, 6,7% schnittfester MOZZARELLA KÄSE, Backhefe, Salz, Zucker, Emulgator (Mono- und Diglyceride von Speisefettsäuren), Champignonpulver, SOJASAUCE (Wasser, SOJABOHNEN, Salz, WEIZENMEHL), Knoblauch, Oregano, Zwiebeln, Petersilie, Röstzwiebeln.',
              },
            ],
          },
          {
            '@type': 'Product',
            name: 'Ristorante Diavola',
            gtin: '4001724039594',
            size: '350 g',
            image:
              'https://www.oetker.de/assets/hygraph/AVtdz8Pl3QxerK0kYX32fz/compress=metadata:true/quality=value:75/output=format:webp/resize=fit:clip,height:662,width:662/cmnxs216phqx108vz9nf0s7yp',
            offers: {
              '@type': 'Offer',
              price: '3.49',
              priceCurrency: 'EUR',
              availability: 'https://schema.org/InStock',
              url: 'https://www.oetker.de/produkte/p/ristorante-diavola',
            },
            additionalProperty: [
              { '@type': 'PropertyValue', name: 'Calories', value: '844 kcal' },
              { '@type': 'PropertyValue', name: 'Fat', value: '41 g' },
              { '@type': 'PropertyValue', name: 'Saturated Fat', value: '14 g' },
              { '@type': 'PropertyValue', name: 'Carbohydrates', value: '83 g' },
              { '@type': 'PropertyValue', name: 'Sugars', value: '11 g' },
              { '@type': 'PropertyValue', name: 'Fiber', value: '6,7 g' },
              { '@type': 'PropertyValue', name: 'Protein', value: '31 g' },
              { '@type': 'PropertyValue', name: 'Sodium', value: '4,5 g' },
              { '@type': 'PropertyValue', name: 'Vegetarian', value: 'No' },
              { '@type': 'PropertyValue', name: 'Vegan', value: 'No' },
              { '@type': 'PropertyValue', name: 'Gluten-Free', value: 'No' },
              { '@type': 'PropertyValue', name: 'Lactose-Free', value: 'No' },
              { '@type': 'PropertyValue', name: 'Halal', value: 'No' },
              { '@type': 'PropertyValue', name: 'MajorAllergens', value: 'Soja, Senf' },
              { '@type': 'PropertyValue', name: 'VerifiedDate', value: '21.02.2026' },
              {
                '@type': 'PropertyValue',
                name: 'Ingredients',
                value:
                  'WEIZENMEHL, 21% Tomatenpüree, 15% KÄSE (schnittfester MOZZARELLA, EDAMER), 8,3% eingelegte Peperonistücke (Peperoni, Wasser, Branntweinessig, Salz, Zucker, Säuerungsmittel (Citronensäure, Essigsäure), Antioxidationsmittel (Ascorbinsäure)), 8,3% Pepperoni-Salami (Schweinefleisch, Speck, Salz, Gewürze, Dextrose, Zwiebelpulver, Knoblauchpulver, Gewürzextrakte, Stabilisator (Natriumnitrit), Antioxidationsmittel (Extrakt aus Rosmarin, Natriumascorbat), Rauch), Wasser, Rapsöl, Backhefe, Zucker, Salz, Paprika, Chilischoten, Oregano, Knoblauch, Petersilie, Zitronensaft, Chiliextrakt.',
              },
            ],
          },
          {
            '@type': 'Product',
            name: 'Ristorante Mozzarella Glutenfrei',
            gtin: '4001724022398',
            size: '370 g',
            image:
              'https://www.oetker.de/assets/hygraph/AVtdz8Pl3QxerK0kYX32fz/compress=metadata:true/quality=value:75/output=format:webp/resize=fit:clip,height:662,width:662/cmnxsjyu2j1h007umike50syu',
            offers: {
              '@type': 'Offer',
              price: '3.69',
              priceCurrency: 'EUR',
              availability: 'https://schema.org/InStock',
              url: 'https://www.oetker.de/produkte/p/ristorante-mozzarella-gluten-free',
            },
            additionalProperty: [
              { '@type': 'PropertyValue', name: 'Calories', value: '836 kcal' },
              { '@type': 'PropertyValue', name: 'Fat', value: '37 g' },
              { '@type': 'PropertyValue', name: 'Saturated Fat', value: '16 g' },
              { '@type': 'PropertyValue', name: 'Carbohydrates', value: '84 g' },
              { '@type': 'PropertyValue', name: 'Sugars', value: '7,6 g' },
              { '@type': 'PropertyValue', name: 'Fiber', value: '6,1 g' },
              { '@type': 'PropertyValue', name: 'Protein', value: '37 g' },
              { '@type': 'PropertyValue', name: 'Sodium', value: '3,4 g' },
              { '@type': 'PropertyValue', name: 'Vegetarian', value: 'Yes' },
              { '@type': 'PropertyValue', name: 'Vegan', value: 'No' },
              { '@type': 'PropertyValue', name: 'Gluten-Free', value: 'Yes' },
              { '@type': 'PropertyValue', name: 'Lactose-Free', value: 'Yes' },
              { '@type': 'PropertyValue', name: 'Halal', value: 'No' },
              { '@type': 'PropertyValue', name: 'MajorAllergens', value: 'Soja, Senf' },
              { '@type': 'PropertyValue', name: 'VerifiedDate', value: '21.02.2026' },
              {
                '@type': 'PropertyValue',
                name: 'Ingredients',
                value:
                  '19% schnittfester MOZZARELLA KÄSE, 15% Tomatenpüree, Wasser, Reismehl, Stärke, 7,8% Cherrytomaten, EDAMER KÄSE, Kartoffelflocken, Rapsöl, Erbseneiweiß, Hefe, Zucker, Basilikum, Salz, Verdickungsmittel (Hydroxypropylmethylcellulose, Xanthan), natives Olivenöl extra, Emulgatoren (Milchsäureester von Mono- und Diglyceriden von Speisefettsäuren, Essigsäureester von Mono- und Diglyceriden von Speisefettsäuren, Mono- und Diglyceride von Speisefettsäuren), Spinat, Petersilie, Glukosesirup, modifizierte Stärke, Knoblauch, Gewürze, Zitronensaft, Dextrose, Oregano, MILCHEIWEISS.',
              },
            ],
          },
          {
            '@type': 'Product',
            name: 'Ristorante Vegetale',
            gtin: '4001724039143',
            size: '385 g',
            image:
              'https://www.oetker.de/assets/hygraph/AVtdz8Pl3QxerK0kYX32fz/compress=metadata:true/quality=value:75/output=format:webp/resize=fit:clip,height:662,width:662/cmnxsjoqqizo307ulubb91wwt',
            offers: {
              '@type': 'Offer',
              price: '3.49',
              priceCurrency: 'EUR',
              availability: 'https://schema.org/InStock',
              url: 'https://www.oetker.de/produkte/p/ristorante-vegetale',
            },
            additionalProperty: [
              { '@type': 'PropertyValue', name: 'Calories', value: '742 kcal' },
              { '@type': 'PropertyValue', name: 'Fat', value: '31 g' },
              { '@type': 'PropertyValue', name: 'Saturated Fat', value: '10 g' },
              { '@type': 'PropertyValue', name: 'Carbohydrates', value: '86 g' },
              { '@type': 'PropertyValue', name: 'Sugars', value: '14 g' },
              { '@type': 'PropertyValue', name: 'Fiber', value: '7,5 g' },
              { '@type': 'PropertyValue', name: 'Protein', value: '26 g' },
              { '@type': 'PropertyValue', name: 'Sodium', value: '3,7 g' },
              { '@type': 'PropertyValue', name: 'Vegetarian', value: 'Yes' },
              { '@type': 'PropertyValue', name: 'Vegan', value: 'No' },
              { '@type': 'PropertyValue', name: 'Gluten-Free', value: 'No' },
              { '@type': 'PropertyValue', name: 'Lactose-Free', value: 'No' },
              { '@type': 'PropertyValue', name: 'Halal', value: 'No' },
              { '@type': 'PropertyValue', name: 'MajorAllergens', value: 'Soja, Senf' },
              { '@type': 'PropertyValue', name: 'VerifiedDate', value: '21.02.2026' },
              {
                '@type': 'PropertyValue',
                name: 'Ingredients',
                value:
                  'WEIZENMEHL, 15% Tomatenpüree, 12% KÄSE (schnittfester MOZZARELLA, EDAMER), 9,0% Cherrytomaten, 9,0% Gemüsepaprika, Wasser, SAUERRAHM, Rapsöl, 3,0% Zwiebeln, 3,0% eingelegte Peperonistücke (Peperoni, Wasser, Branntweinessig, Salz, Zucker, Säuerungsmittel (Citronensäure, Essigsäure), Antioxidationsmittel (Ascorbinsäure)), zerkleinerte Oliven, Backhefe, Salz, Zucker, Pfeffer, Knoblauch, Chilischoten, Oregano, Petersilie, Zitronensaft, Paprika, Chiliextrakt.',
              },
            ],
          },
          {
            '@type': 'Product',
            name: 'Ristorante Mozzarella',
            gtin: '4001724039112',
            size: '355 g',
            image:
              'https://www.oetker.de/assets/hygraph/AVtdz8Pl3QxerK0kYX32fz/compress=metadata:true/quality=value:75/output=format:webp/resize=fit:clip,height:662,width:662/cmnxse3agij7j07w6uquq0mfd',
            offers: {
              '@type': 'Offer',
              price: '3.49',
              priceCurrency: 'EUR',
              availability: 'https://schema.org/InStock',
              url: 'https://www.oetker.de/produkte/p/ristorante-mozzarella',
            },
            additionalProperty: [
              { '@type': 'PropertyValue', name: 'Calories', value: '865 kcal' },
              { '@type': 'PropertyValue', name: 'Fat', value: '42 g' },
              { '@type': 'PropertyValue', name: 'Saturated Fat', value: '14 g' },
              { '@type': 'PropertyValue', name: 'Carbohydrates', value: '82 g' },
              { '@type': 'PropertyValue', name: 'Sugars', value: '10 g' },
              { '@type': 'PropertyValue', name: 'Fiber', value: '5,8 g' },
              { '@type': 'PropertyValue', name: 'Protein', value: '36 g' },
              { '@type': 'PropertyValue', name: 'Sodium', value: '3,6 g' },
              { '@type': 'PropertyValue', name: 'Vegetarian', value: 'Yes' },
              { '@type': 'PropertyValue', name: 'Vegan', value: 'No' },
              { '@type': 'PropertyValue', name: 'Gluten-Free', value: 'No' },
              { '@type': 'PropertyValue', name: 'Lactose-Free', value: 'No' },
              { '@type': 'PropertyValue', name: 'Halal', value: 'No' },
              { '@type': 'PropertyValue', name: 'MajorAllergens', value: 'Soja, Senf' },
              { '@type': 'PropertyValue', name: 'VerifiedDate', value: '21.02.2026' },
              {
                '@type': 'PropertyValue',
                name: 'Ingredients',
                value:
                  'WEIZENMEHL, 24% schnittfester MOZZARELLA KÄSE, 16% Tomatenpüree, 10% Cherrytomaten, Wasser, Rapsöl, natives Olivenöl extra, Basilikum, Backhefe, Salz, Zucker, Petersilie, 0,3% PECORINO HARTKÄSE, Knoblauch, Zwiebeln, Oregano, Pfeffer, Zitronensaft, Paprika, Röstzwiebeln',
              },
            ],
          },
          {
            '@type': 'Product',
            name: 'Ristorante Tonno',
            gtin: '4001724038993',
            size: '355 g',
            image:
              'https://www.oetker.de/assets/hygraph/AVtdz8Pl3QxerK0kYX32fz/compress=metadata:true/quality=value:75/output=format:webp/resize=fit:clip,height:662,width:662/cmnxs0xlrhsy407umcy24vpm3',
            offers: {
              '@type': 'Offer',
              price: '3.49',
              priceCurrency: 'EUR',
              availability: 'https://schema.org/InStock',
              url: 'https://www.oetker.de/produkte/p/ristorante-tonno',
            },
            additionalProperty: [
              { '@type': 'PropertyValue', name: 'Calories', value: '825 kcal' },
              { '@type': 'PropertyValue', name: 'Fat', value: '37 g' },
              { '@type': 'PropertyValue', name: 'Saturated Fat', value: '9,7 g' },
              { '@type': 'PropertyValue', name: 'Carbohydrates', value: '83 g' },
              { '@type': 'PropertyValue', name: 'Sugars', value: '11 g' },
              { '@type': 'PropertyValue', name: 'Fiber', value: '6,2 g' },
              { '@type': 'PropertyValue', name: 'Protein', value: '35 g' },
              { '@type': 'PropertyValue', name: 'Sodium', value: '3,3 g' },
              { '@type': 'PropertyValue', name: 'Vegetarian', value: 'No' },
              { '@type': 'PropertyValue', name: 'Vegan', value: 'No' },
              { '@type': 'PropertyValue', name: 'Gluten-Free', value: 'No' },
              { '@type': 'PropertyValue', name: 'Lactose-Free', value: 'No' },
              { '@type': 'PropertyValue', name: 'Halal', value: 'No' },
              { '@type': 'PropertyValue', name: 'MajorAllergens', value: 'Soja, Senf' },
              { '@type': 'PropertyValue', name: 'VerifiedDate', value: '21.02.2026' },
              {
                '@type': 'PropertyValue',
                name: 'Ingredients',
                value:
                  'WEIZENMEHL, 19% Tomatenpüree, 16% KÄSE (schnittfester MOZZARELLA, EDAMER), 9,2% THUNFISCH (Katsuwonus pelamis), Wasser, Rapsöl, 5,6% Zwiebeln, 1,8% frittierte Zwiebeln (Zwiebeln, Rapsöl, Sonnenblumenöl), Backhefe, Salz, Zucker, natives Olivenöl extra, Sonnenblumenöl, Oregano, Basilikum, Petersilie, Schnittlauch, Knoblauch, Paprika, Pfeffer.',
              },
            ],
          },
          {
            '@type': 'Product',
            name: 'Ristorante Quattro Formaggi',
            gtin: '4001724038870',
            size: '340 g',
            image:
              'https://www.oetker.de/assets/hygraph/AVtdz8Pl3QxerK0kYX32fz/compress=metadata:true/quality=value:75/output=format:webp/resize=fit:clip,height:662,width:662/cmnxsgoqbit1707ul416bt1ag',
            offers: {
              '@type': 'Offer',
              price: '3.49',
              priceCurrency: 'EUR',
              availability: 'https://schema.org/InStock',
              url: 'https://www.oetker.de/produkte/p/ristorante-quattro-formaggi',
            },
            additionalProperty: [
              { '@type': 'PropertyValue', name: 'Calories', value: '875 kcal' },
              { '@type': 'PropertyValue', name: 'Fat', value: '43 g' },
              { '@type': 'PropertyValue', name: 'Saturated Fat', value: '19 g' },
              { '@type': 'PropertyValue', name: 'Carbohydrates', value: '82 g' },
              { '@type': 'PropertyValue', name: 'Sugars', value: '9,6 g' },
              { '@type': 'PropertyValue', name: 'Fiber', value: '5,4 g' },
              { '@type': 'PropertyValue', name: 'Protein', value: '36 g' },
              { '@type': 'PropertyValue', name: 'Sodium', value: '3,5 g' },
              { '@type': 'PropertyValue', name: 'Vegetarian', value: 'Yes' },
              { '@type': 'PropertyValue', name: 'Vegan', value: 'No' },
              { '@type': 'PropertyValue', name: 'Gluten-Free', value: 'No' },
              { '@type': 'PropertyValue', name: 'Lactose-Free', value: 'No' },
              { '@type': 'PropertyValue', name: 'Halal', value: 'No' },
              { '@type': 'PropertyValue', name: 'MajorAllergens', value: 'Senf' },
              { '@type': 'PropertyValue', name: 'VerifiedDate', value: '21.02.2026' },
              {
                '@type': 'PropertyValue',
                name: 'Ingredients',
                value:
                  'WEIZENMEHL, 19% Tomatenpüree, 10% schnittfester MOZZARELLA KÄSE, 10% EDAMER KÄSE, Wasser, SCHLAGSAHNE, Rapsöl, 4,1% EMMENTALER KÄSE, Backhefe, 0,8% BLAUSCHIMMELKÄSE, Salz, Zucker, Basilikum, SOJASAUCE (Wasser, SOJABOHNEN, Salz, WEIZENMEHL), natives Olivenöl extra, modifizierte Stärke, Gewürze, Oregano, Knoblauch.',
              },
            ],
          },
          {
            '@type': 'Product',
            name: 'Ristorante Hawaii',
            gtin: '4001724039082',
            size: '355 g',
            image:
              'https://www.oetker.de/assets/hygraph/AVtdz8Pl3QxerK0kYX32fz/compress=metadata:true/quality=value:75/output=format:webp/resize=fit:clip,height:662,width:662/cmnxsf6ycilnb07w6iqk6tk0x',
            offers: {
              '@type': 'Offer',
              price: '3.49',
              priceCurrency: 'EUR',
              availability: 'https://schema.org/InStock',
              url: 'https://www.oetker.de/produkte/p/ristorante-hawaii',
            },
            additionalProperty: [
              { '@type': 'PropertyValue', name: 'Calories', value: '771 kcal' },
              { '@type': 'PropertyValue', name: 'Fat', value: '30 g' },
              { '@type': 'PropertyValue', name: 'Saturated Fat', value: '9,9 g' },
              { '@type': 'PropertyValue', name: 'Carbohydrates', value: '91 g' },
              { '@type': 'PropertyValue', name: 'Sugars', value: '19 g' },
              { '@type': 'PropertyValue', name: 'Fiber', value: '6,3 g' },
              { '@type': 'PropertyValue', name: 'Protein', value: '30 g' },
              { '@type': 'PropertyValue', name: 'Sodium', value: '3,5 g' },
              { '@type': 'PropertyValue', name: 'Vegetarian', value: 'No' },
              { '@type': 'PropertyValue', name: 'Vegan', value: 'No' },
              { '@type': 'PropertyValue', name: 'Gluten-Free', value: 'No' },
              { '@type': 'PropertyValue', name: 'Lactose-Free', value: 'No' },
              { '@type': 'PropertyValue', name: 'Halal', value: 'No' },
              { '@type': 'PropertyValue', name: 'MajorAllergens', value: 'Soja, Senf' },
              { '@type': 'PropertyValue', name: 'VerifiedDate', value: '21.02.2026' },
              {
                '@type': 'PropertyValue',
                name: 'Ingredients',
                value:
                  'WEIZENMEHL, 19% Tomatenpüree, 15% KÄSE (schnittfester MOZZARELLA, EDAMER), 14% eingelegte Ananasstücke (Ananasstücke, Wasser, Zucker, Säuerungsmittel (Citronensäure)), Wasser, 6,8% gekochter Hinterschinken (Schweinefleisch, Wasser, Salz, Dextrose, Stabilisatoren (Diphosphate, Triphosphate, Natriumnitrit), Antioxidationsmittel (Natriumascorbat), Gewürzextrakte), Rapsöl, Backhefe, Zucker, Salz, natives Olivenöl extra, Oregano, Ingwer, Petersilie.',
              },
            ],
          },
          {
            '@type': 'Product',
            name: 'Ristorante Salame',
            gtin: '4001724038900',
            size: '320 g',
            image:
              'https://www.oetker.de/assets/hygraph/AVtdz8Pl3QxerK0kYX32fz/compress=metadata:true/quality=value:75/output=format:webp/resize=fit:clip,height:662,width:662/cmnxsocwyjb4j07uli7iknodd',
            offers: {
              '@type': 'Offer',
              price: '3.49',
              priceCurrency: 'EUR',
              availability: 'https://schema.org/InStock',
              url: 'https://www.oetker.de/produkte/p/ristorante-salame',
            },
            additionalProperty: [
              { '@type': 'PropertyValue', name: 'Calories', value: '854 kcal' },
              { '@type': 'PropertyValue', name: 'Fat', value: '43 g' },
              { '@type': 'PropertyValue', name: 'Saturated Fat', value: '15 g' },
              { '@type': 'PropertyValue', name: 'Carbohydrates', value: '82 g' },
              { '@type': 'PropertyValue', name: 'Sugars', value: '9,5 g' },
              { '@type': 'PropertyValue', name: 'Fiber', value: '5,9 g' },
              { '@type': 'PropertyValue', name: 'Protein', value: '32 g' },
              { '@type': 'PropertyValue', name: 'Sodium', value: '4,2 g' },
              { '@type': 'PropertyValue', name: 'Vegetarian', value: 'No' },
              { '@type': 'PropertyValue', name: 'Vegan', value: 'No' },
              { '@type': 'PropertyValue', name: 'Gluten-Free', value: 'No' },
              { '@type': 'PropertyValue', name: 'Lactose-Free', value: 'No' },
              { '@type': 'PropertyValue', name: 'Halal', value: 'No' },
              { '@type': 'PropertyValue', name: 'MajorAllergens', value: 'Soja, Senf' },
              { '@type': 'PropertyValue', name: 'VerifiedDate', value: '21.02.2026' },
              {
                '@type': 'PropertyValue',
                name: 'Ingredients',
                value:
                  'WEIZENMEHL, 21% Tomatenpüree, 12% schnittfester MOZZARELLA KÄSE, 12% Salami (Schweinefleisch, Speck, Salz, Gewürze, Dextrose, Zwiebelpulver, Knoblauchpulver, Gewürzextrakte, Stabilisator (Natriumnitrit), Antioxidationsmittel (Extrakt aus Rosmarin, Natriumascorbat), Rauch), Wasser, Rapsöl, 4,6% EDAMER KÄSE, Backhefe, Salz, Zucker, Dextrose, Oregano, Basilikum, Gewürze, Petersilie.',
              },
            ],
          },
          {
            '@type': 'Product',
            name: 'Ristorante Spinaci',
            gtin: '4001724039020',
            size: '390 g',
            image:
              'https://www.oetker.de/assets/hygraph/AVtdz8Pl3QxerK0kYX32fz/compress=metadata:true/quality=value:75/output=format:webp/resize=fit:clip,height:662,width:662/cmnxsgyf0ipw907w69lntggi3',
            offers: {
              '@type': 'Offer',
              price: '3.49',
              priceCurrency: 'EUR',
              availability: 'https://schema.org/InStock',
              url: 'https://www.oetker.de/produkte/p/ristorante-spinaci',
            },
            additionalProperty: [
              { '@type': 'PropertyValue', name: 'Calories', value: '861 kcal' },
              { '@type': 'PropertyValue', name: 'Fat', value: '45 g' },
              { '@type': 'PropertyValue', name: 'Saturated Fat', value: '11 g' },
              { '@type': 'PropertyValue', name: 'Carbohydrates', value: '82 g' },
              { '@type': 'PropertyValue', name: 'Sugars', value: '9,3 g' },
              { '@type': 'PropertyValue', name: 'Fiber', value: '7,5 g' },
              { '@type': 'PropertyValue', name: 'Protein', value: '28 g' },
              { '@type': 'PropertyValue', name: 'Sodium', value: '3,8 g' },
              { '@type': 'PropertyValue', name: 'Vegetarian', value: 'No' },
              { '@type': 'PropertyValue', name: 'Vegan', value: 'No' },
              { '@type': 'PropertyValue', name: 'Gluten-Free', value: 'No' },
              { '@type': 'PropertyValue', name: 'Lactose-Free', value: 'No' },
              { '@type': 'PropertyValue', name: 'Halal', value: 'No' },
              { '@type': 'PropertyValue', name: 'MajorAllergens', value: 'Soja, Senf' },
              { '@type': 'PropertyValue', name: 'VerifiedDate', value: '21.02.2026' },
              {
                '@type': 'PropertyValue',
                name: 'Ingredients',
                value:
                  'WEIZENMEHL, 20% Spinat, 18% Tomatenpüree, 14% KÄSE (schnittfester MOZZARELLA, EDAMER), Wasser, Rapsöl, Backhefe, Salz, Zucker, modifizierte Stärke, Emulgator (Mono- und Diglyceride von Speisefettsäuren), Knoblauch, Zwiebeln, Röstzwiebeln, Chilipulver.',
              },
            ],
          },
          {
            '@type': 'Product',
            name: 'Ristorante Salame Glutenfrei',
            gtin: '4001724022473',
            size: '315 g',
            image:
              'https://www.oetker.de/assets/hygraph/AVtdz8Pl3QxerK0kYX32fz/compress=metadata:true/quality=value:75/output=format:webp/resize=fit:clip,height:662,width:662/cmnxs3p1ui27408uokn03zc66',
            offers: {
              '@type': 'Offer',
              price: '3.69',
              priceCurrency: 'EUR',
              availability: 'https://schema.org/InStock',
              url: 'https://www.oetker.de/produkte/p/ristorante-salame-gluten-free',
            },
            additionalProperty: [
              { '@type': 'PropertyValue', name: 'Calories', value: '780 kcal' },
              { '@type': 'PropertyValue', name: 'Fat', value: '34 g' },
              { '@type': 'PropertyValue', name: 'Saturated Fat', value: '15 g' },
              { '@type': 'PropertyValue', name: 'Carbohydrates', value: '82 g' },
              { '@type': 'PropertyValue', name: 'Sugars', value: '6,5 g' },
              { '@type': 'PropertyValue', name: 'Fiber', value: '5,9 g' },
              { '@type': 'PropertyValue', name: 'Protein', value: '33 g' },
              { '@type': 'PropertyValue', name: 'Sodium', value: '4,3 g' },
              { '@type': 'PropertyValue', name: 'Vegetarian', value: 'No' },
              { '@type': 'PropertyValue', name: 'Vegan', value: 'No' },
              { '@type': 'PropertyValue', name: 'Gluten-Free', value: 'Yes' },
              { '@type': 'PropertyValue', name: 'Lactose-Free', value: 'Yes' },
              { '@type': 'PropertyValue', name: 'Halal', value: 'No' },
              { '@type': 'PropertyValue', name: 'MajorAllergens', value: 'Soja, Senf' },
              { '@type': 'PropertyValue', name: 'VerifiedDate', value: '21.02.2026' },
              {
                '@type': 'PropertyValue',
                name: 'Ingredients',
                value:
                  '18% Tomatenpüree, Reismehl, 15% KÄSE (schnittfester MOZZARELLA, EDAMER), Wasser, 12% Salami (Schweinefleisch, Speck, Salz, Gewürze, Dextrose, Zwiebelpulver, Knoblauchpulver, Gewürzextrakte, Stabilisator (Natriumnitrit), Antioxidationsmittel (Extrakt aus Rosmarin, Natriumascorbat), Rauch), Stärke, Kartoffelflocken, Erbseneiweiß, Rapsöl, Hefe, Zucker, Salz, Verdickungsmittel (Hydroxypropylmethylcellulose, Xanthan), natives Olivenöl extra, Glukosesirup, Emulgatoren (Milchsäureester von Mono- und Diglyceriden von Speisefettsäuren, Essigsäureester von Mono- und Diglyceriden von Speisefettsäuren), modifizierte Stärke, Oregano, Gewürze, Knoblauch, Dextrose, MILCHEIWEISS.',
              },
            ],
          },
          {
            '@type': 'Product',
            name: 'Ristorante Piccola Margherita',
            gtin: '4001724038818',
            size: '270 g',
            image:
              'https://www.oetker.de/assets/hygraph/AVtdz8Pl3QxerK0kYX32fz/compress=metadata:true/quality=value:75/output=format:webp/resize=fit:clip,height:662,width:662/cmnxs48x3hz9b07uloxl8qm6h',
            offers: {
              '@type': 'Offer',
              price: '3.49',
              priceCurrency: 'EUR',
              availability: 'https://schema.org/InStock',
              url: 'https://www.oetker.de/produkte/p/ristorante-piccola-margherita',
            },
            additionalProperty: [
              { '@type': 'PropertyValue', name: 'Calories', value: '352 kcal' },
              { '@type': 'PropertyValue', name: 'Fat', value: '16 g' },
              { '@type': 'PropertyValue', name: 'Saturated Fat', value: '6,1 g' },
              { '@type': 'PropertyValue', name: 'Carbohydrates', value: '37 g' },
              { '@type': 'PropertyValue', name: 'Sugars', value: '4,2 g' },
              { '@type': 'PropertyValue', name: 'Fiber', value: '2,5 g' },
              { '@type': 'PropertyValue', name: 'Protein', value: '14 g' },
              { '@type': 'PropertyValue', name: 'Sodium', value: '1,4 g' },
              { '@type': 'PropertyValue', name: 'Vegetarian', value: 'Yes' },
              { '@type': 'PropertyValue', name: 'Vegan', value: 'No' },
              { '@type': 'PropertyValue', name: 'Gluten-Free', value: 'No' },
              { '@type': 'PropertyValue', name: 'Lactose-Free', value: 'No' },
              { '@type': 'PropertyValue', name: 'Halal', value: 'No' },
              { '@type': 'PropertyValue', name: 'MajorAllergens', value: 'Soja, Senf' },
              { '@type': 'PropertyValue', name: 'VerifiedDate', value: '21.02.2026' },
              {
                '@type': 'PropertyValue',
                name: 'Ingredients',
                value:
                  'WEIZENMEHL, 23% Tomatenpüree, 12% schnittfester MOZZARELLA KÄSE, 12% GOUDA KÄSE, Wasser, Rapsöl, Backhefe, Zucker, Salz, Oregano, Basilikum, Petersilie, Paprika.',
              },
            ],
          },
        ],
      },
      {
        '@type': 'FAQPage',
        mainEntity: [
          {
            '@type': 'Question',
            name: 'Was ist Dr. Oetker Ristorante Pizza?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Dr. Oetker Ristorante Pizza ist eine Reihe von Tiefkühlpizzen von Dr. Oetker, die ein italienisches Restaurant-Erlebnis für zu Hause bieten sollen. Die Produktreihe ist für ihren dünnen, knusprigen Boden, sorgfältig ausgewählte Beläge und ausgewogene Geschmackskombinationen bekannt.',
            },
          },
          {
            '@type': 'Question',
            name: 'Wie viele Sorten von Dr. Oetker Ristorante Pizza gibt es?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Dr. Oetker bietet in Deutschland 18 Sorten der Ristorante Pizza an.',
            },
          },
          {
            '@type': 'Question',
            name: 'Welche verschiedenen Sorten von Dr. Oetker Ristorante Pizza gibt es?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Zu den Sorten der Dr. Oetker Ristorante Pizza gehören Ristorante Pasta, Ristorante Salame Mozzarella Pesto, Ristorante Margherita Pomodori Vegan, Ristorante Pepperoni-Salame, Ristorante Speciale, Ristorante Funghi, Ristorante Diavola, Ristorante Mozzarella Glutenfrei, Ristorante Vegetale, Ristorante Mozzarella, Ristorante Tonno, Ristorante Quattro Formaggi, Ristorante Hawaii, Ristorante Salame, Ristorante Spinaci, Ristorante Salame Glutenfrei, Ristorante Piccola Margherita und Ristorante Piccola Salame.',
            },
          },
          {
            '@type': 'Question',
            name: 'Was definiert Dr. Oetker Ristorante Pizza als Produktkategorie?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Die Produktkategorie der Dr. Oetker Ristorante Pizza wird durch den dünnen Boden definiert.',
            },
          },
          {
            '@type': 'Question',
            name: 'Was unterscheidet Dr. Oetker Ristorante Pizza von anderen Dr. Oetker Tiefkühlpizzen?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Dr. Oetker Ristorante Pizza unterscheidet sich von anderen Dr. Oetker Tiefkühlpizzen durch ihren dünnen und knusprigen Boden sowie den Belag bis zum Rand.',
            },
          },
          {
            '@type': 'Question',
            name: 'Was ist das Konzept hinter Dr. Oetker Ristorante Pizza?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Dr. Oetker Ristorante Pizza soll eine Pizza für den täglichen Genuss bieten, die geschmacklich an eine Pizza aus einem italienischen Restaurant erinnert.',
            },
          },
          {
            '@type': 'Question',
            name: 'Warum wird Dr. Oetker Ristorante Pizza als italienischer Restaurantstil beschrieben?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Dr. Oetker beschreibt Ristorante Pizza als italienischen Restaurantstil, weil die Pizza geschmacklich an eine Pizza aus einem italienischen Restaurant erinnern soll.',
            },
          },
          {
            '@type': 'Question',
            name: 'Was macht den Teig von Dr. Oetker Ristorante Pizza besonders?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Der Teig der Dr. Oetker Ristorante Pizza zeichnet sich insbesondere durch seine Knusprigkeit aus.',
            },
          },
          {
            '@type': 'Question',
            name: 'Ist der Boden von Dr. Oetker Ristorante Pizza dünn und knusprig?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Dr. Oetker Ristorante Pizza verfügt über einen dünnen und knusprigen Boden.',
            },
          },
          {
            '@type': 'Question',
            name: 'Wie unterscheidet sich Dr. Oetker Ristorante Pizza von Dr. Oetker Suprema Pizza?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Dr. Oetker Ristorante Pizza unterscheidet sich von Dr. Oetker Suprema Pizza durch eine andere Teigrezeptur, ein anderes Geschmackserlebnis, andere Eigenschaften des Bodens sowie eine andere Größe.',
            },
          },
          {
            '@type': 'Question',
            name: 'Wie unterscheidet sich Dr. Oetker Ristorante Pizza von Dr. Oetker Tradizionale Pizza?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Dr. Oetker Ristorante Pizza unterscheidet sich von Dr. Oetker Tradizionale Pizza durch eine andere Teigrezeptur, ein anderes Geschmackserlebnis und andere Eigenschaften des Bodens.',
            },
          },
          {
            '@type': 'Question',
            name: 'Gilt Dr. Oetker Ristorante Pizza als Premium-Tiefkühlpizza?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Dr. Oetker Ristorante Pizza wird nicht als Premium-Tiefkühlpizza positioniert.',
            },
          },
          {
            '@type': 'Question',
            name: 'Welche Beläge sind typischerweise auf Dr. Oetker Ristorante Pizza erhältlich?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Typische Beläge der Dr. Oetker Ristorante Pizza sind Mozzarella, Salame, Quattro Formaggi, Tonno und Speciale.',
            },
          },
          {
            '@type': 'Question',
            name: 'Sind die Beläge auf Dr. Oetker Ristorante Pizza gleichmäßig verteilt?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Die Beläge der Dr. Oetker Ristorante Pizza sind je nach Sorte überwiegend gleichmäßig verteilt.',
            },
          },
          {
            '@type': 'Question',
            name: 'Ist Dr. Oetker Ristorante Pizza für Vegetarier geeignet?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Einige Sorten der Dr. Oetker Ristorante Pizza sind für Vegetarier geeignet.',
            },
          },
          {
            '@type': 'Question',
            name: 'Ist Dr. Oetker Ristorante Pizza für Veganer geeignet?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Dr. Oetker bietet eine vegane Variante der Ristorante Pizza an.',
            },
          },
          {
            '@type': 'Question',
            name: 'Enthält Dr. Oetker Ristorante Pizza Allergene wie Gluten oder Milchprodukte?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Dr. Oetker Ristorante Pizza kann Allergene wie Gluten oder Milchprodukte enthalten.',
            },
          },
          {
            '@type': 'Question',
            name: 'Welche Zutaten werden für den Teig von Dr. Oetker Ristorante Pizza verwendet?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Für den Teig der Dr. Oetker Ristorante Pizza werden unter anderem Weizen, Hefe, Wasser und Salz verwendet.',
            },
          },
          {
            '@type': 'Question',
            name: 'Wie sollte Dr. Oetker Ristorante Pizza vor dem Backen gelagert werden?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Dr. Oetker Ristorante Pizza sollte bis zur Zubereitung tiefgekühlt gelagert werden.',
            },
          },
          {
            '@type': 'Question',
            name: 'Sollte Dr. Oetker Ristorante Pizza tiefgekühlt gebacken werden?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Dr. Oetker empfiehlt, Ristorante Pizza direkt tiefgekühlt zu backen.',
            },
          },
          {
            '@type': 'Question',
            name: 'Welche Ofentemperatur wird für Dr. Oetker Ristorante Pizza empfohlen?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Für die Zubereitung der Dr. Oetker Ristorante Pizza wird eine Ofentemperatur von 200 bis 220 Grad Celsius empfohlen.',
            },
          },
          {
            '@type': 'Question',
            name: 'Wie lange muss Dr. Oetker Ristorante Pizza gebacken werden?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Die empfohlene Backzeit für Dr. Oetker Ristorante Pizza beträgt 11 bis 14 Minuten.',
            },
          },
          {
            '@type': 'Question',
            name: 'Muss der Ofen für Dr. Oetker Ristorante Pizza vorgeheizt werden?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Dr. Oetker empfiehlt, den Ofen vor dem Backen der Ristorante Pizza vorzuheizen.',
            },
          },
          {
            '@type': 'Question',
            name: 'Kann Dr. Oetker Ristorante Pizza im Airfryer zubereitet werden?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Die Zubereitung von Dr. Oetker Ristorante Pizza im Airfryer wird von Dr. Oetker nicht empfohlen.',
            },
          },
          {
            '@type': 'Question',
            name: 'Welche Textur hat Dr. Oetker Ristorante Pizza nach dem Backen?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Nach dem Backen zeichnet sich Dr. Oetker Ristorante Pizza durch einen knusprigen Boden aus.',
            },
          },
          {
            '@type': 'Question',
            name: 'Wie schmeckt Dr. Oetker Ristorante Pizza im Vergleich zu dickeren Tiefkühlpizzen?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Dr. Oetker Ristorante Pizza bietet im Vergleich zu dickeren Tiefkühlpizzen ein ausgewogeneres Verhältnis zwischen Teig und Belag.',
            },
          },
          {
            '@type': 'Question',
            name: 'Wie groß ist eine Dr. Oetker Ristorante Pizza?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Eine Dr. Oetker Ristorante Pizza hat einen Durchmesser von ungefähr 25 Zentimetern.',
            },
          },
        ],
      },
    ],
  };
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
    />
  );
};
